// Last update 18. des 2023
import { createTheme, ThemeProvider } from '@mui/material/styles';

import {
  createBrowserRouter,
  RouterProvider,
  // useSearchParams,
} from "react-router-dom"
import axios from 'axios'
import {
  QueryClient,
  QueryClientProvider,
  // useQuery,
  QueryFunction,
  // MutateFunction
} from "@tanstack/react-query";

import './styles/global.css'

import AppForm from "./forms/AppForm";
import { CssBaseline, Container } from "@mui/material";
import { ReturnPage } from "./pages/ReturnPage";
import { Hopper } from "./pages/Hopper";
// import ApplicationForm from './components/ApplicationForm';
// import {FormData} from './lib/interfaces/IApplicationForm'

declare module '@mui/material/styles' {
  interface Theme {
    status: {
      danger: string;
    };
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    status?: {
      danger?: string;
    };
  }
  interface PaletteOptions {
    neutral: PaletteOptions['primary'];
  }
  interface Palette {
    neutral: Palette['primary'];
  }
  interface PaletteColor {
    // light?: string;
    main: string;
    // dark?: string;
    darker?: string;
    // contrastText?: string;
  }
}


const router = createBrowserRouter([
  {
    // k is optional for application key (id)
    path: "/:s/:c/:k?",
    element: <AppForm />,
  },
  {
    path: "/ret/:s/:c/:k",
    element: <Hopper />
  },
  {
    path: "/",
    element: <ReturnPage />
  }

],
  // this is the url before .htaccess redirect, i.e. the url published to users, comment out for dev
  {basename: '/form'}
  // dæmi f. dev: http://localhost:3000/82/3kLvH4zDERevaYtd/

  // package.json contains: "homepage": "https://tonviska.is/react/appform" 
  // which is the real folder on the server and users do not see
);

const defaultQueryFn: QueryFunction = async ({ queryKey }) => {
  const { data } = await axios.get(`https://tonviska.is/api/v1${queryKey[0]}`)
  return data
}

// interface RouteParams {
//   s: string
//   c: string
// }

//////////////////////////////
function App() {

  const theme = createTheme({
    palette: {
      neutral: {
        main: '#64748B',
        contrastText: '#fff',
      },
      primary: {
        main: '#2a7473',
        // darker: '#053e85',
      },
      secondary: {
        main: '#aa5453',
        // darker: '#053e85',
      },
      // alert: {
      //   main: '#ff7777',
      //   darker: '#ee7777',
      // },
      // warning: {
      //   main: '#ff7777',
      //   darker: '$ee7777',
      // }
    },
  });

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        queryFn: defaultQueryFn,
        staleTime: 15000,
        // notifyOnChangeProps: 'tracked',
      },
    },
  });

  return (
    <>
     <ThemeProvider theme={theme}>

      <CssBaseline />
      <Container maxWidth="xl">
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </Container>
     </ThemeProvider>
    </>
  );
}

export default App;
